const authKeys = {
  accessToken: 'auth:access_token',
  hideBalances: 'auth:show-balances',
  passwordResetNumber: 'auth:password-reset-number',
  refreshToken: 'auth:refresh_token',
  sessionTimer: 'auth:session-timer',
  sumSubLastLivenessToken: 'auth:sumsub-last-liveness-token',
  user: 'auth:user',
  userId: 'auth:userId',
};
const promotionKeys = {
  genericWheel: 'generic-wheel:spin-count',
};
const marketingKeys = {
  bannerTag: 'BTAGCOOKIE',
  closedPromoPopUps: 'marketing:closed-promo-pop-ups',
  deletedNotificationIds: 'marketing:deleted-notifications',
  notifications: 'marketing:notifications',
  marketingSession: 'MkSession',
  masterToken: 'MT',
  optinSession: 'marketing:opt-in-session',
  originalQueryString: 'OriginalQueryString',
  referrerBannerTag: 'REFERRERBTAGCOOKIE',
  sessionToken: 'ST',
  signUpCode: 'marketing:sign-up-code',
  toasts: 'marketing:toasts',
  toastsPerSession: 'marketing:toast::session',
  toastsPerSessionThresholdMet: 'marketing:toast::session-threshold-met',
  viewedToasts: 'marketing:toast::viewed',
  welcomeOfferRegPrize: 'welcomeOfferPrizeSelect',
};

const siteConfigKeys = {
  // !NB: without prefix for external parties
  locale: 'locale',
  deviceInfo: 'site:device-info',
  deviceIdentifier: 'site:device-identifier',
  buildTimestamp: 'site:build-time-stamp',
  // !NB: without prefix for external parties
  environment: 'environment',
  acceptCookies: 'site:cookies-accepted',
  persistPanel: (panelName: string) => `site:panel-${panelName}`,
  colorMode: 'nuxt-color-mode',
  webSocketPingInterval: 59000,
  webSocketPingMessage: 'ping',
};

const developerConfigKeys = {
  debugDisableCache: 'debug:disable-cache',
  debugEnvironment: 'debug:environment',
  debugFeatureFlagPersist: 'debug:persist',
  debugFeatureFlagState: 'debug:feature-flag-state',
  debugQueryStrings: 'debug:query-strings',
  debugRegion: 'debug:region',
  debugWebSocket: 'debug:web-socket',
};

const navigationKeys = {
  gameLaunchComponent: 'navigation:component',
  lastVertical: (userId: string) => `navigation:last-vertical:${userId}`,
  lastCategory: (userId: string) => `navigation:last-category:${userId}`,
  lastPosition: (userId: string) => `navigation:last-position:${userId}`,
  lastRoute: (userId: string) => `navigation:last-route:${userId}`,
  lastGame: (userId: string) => `navigation:last-game:${userId}`,
  hasRestoredSession: (userId: string) =>
    `navigation:has-restored-session:${userId}`,
  optOutShowSimilarGames: (userId: string) =>
    `navigation:opted-out-show-similar-games:${userId}`,
  demoPlayRoute: 'demo-play',
  demoPlayTimeoutFallback: 900000,
};

const connexKeys = {
  cx: (liveChatId: string) => `cnx_cx_livechat-jackpotcity${liveChatId}`,
  pp: (liveChatId: string) => `cnx_pp_livechat-jackpotcity${liveChatId}`,
  it: (liveChatId: string) => `cnx_it_livechat-jackpotcity${liveChatId}`,
  setInteraction: 'cnx:set-interaction',
};

const welcomeOfferKeys = {
  successfullyClaimed: 'reward-successfully-claimed',
  claimOneReward: 'claim-one-reward',
  inProgress: 'in-progress',
};

const personalisedPlayerKeys = {
  favorites: (userId: string) => `personalised:favorites:${userId}`,
  mostLiked: () => 'personalised:most-liked',
  recentSearches: (userId: string) => `personalised:recent-searches:${userId}`,
  recentlyPlayed: (userId: string) => `personalised:recently-played:${userId}`,
  recommended: (userId: string) => `personalised:recommended:${userId}`,
};

const partnerKeys = {
  streamingPartnerRequest: 'partners:streaming-request',
};

const pushNotificationKeys = {
  vapidKey:
    'BM9oCn7LTzELRKeegQQVZo_0gRcTQtoouxHAtYMHLp9GdFjUNj7anmBK1qWbP226mh3bAje2FoskzTzAqnUkLfs',
  pushTokenKey: 'notification-token',
  pushAccessTokenKey: 'notification-access-token',
  firebaseSwScript: '/firebase-messaging-sw.js',
};

const tradeDeskKeys = {
  tradeDeskExternalRef: 'ttd_TDID',
};

export const globalKeys = {
  authKeys,
  connexKeys,
  developerConfigKeys,
  marketingKeys,
  navigationKeys,
  partnerKeys,
  personalisedPlayerKeys,
  promotionKeys,
  pushNotificationKeys,
  siteConfigKeys,
  tradeDeskKeys,
  welcomeOfferKeys,
};
